export type Network = 'tron' | 'ethereum' | 'unknown';

export function detectNetwork(address?: string | null): Network {
  if (!address) return 'unknown';
  if (/^T[a-zA-Z0-9]{33}$/.test(address)) return 'tron';
  if (/^0x[a-fA-F0-9]{40}$/.test(address)) return 'ethereum';
  return 'unknown';
}

export function networkLabel(network: Network): string {
  if (network === 'tron') return 'TRON';
  if (network === 'ethereum') return 'Ethereum';
  return '';
}

export function explorerUrl(network: Network, hash: string): string | null {
  const clean = hash.trim();
  if (!clean) return null;
  if (network === 'tron') return `https://tronscan.org/#/transaction/${clean}`;
  if (network === 'ethereum') return `https://etherscan.io/tx/${clean}`;
  return null;
}

// Validate a hash string shape (64 hex, optional 0x).
// Returns true for empty string as well (empty = no hash entered yet).
export function isValidTxHash(hash: string): boolean {
  if (!hash) return true;
  return /^(0x)?[0-9a-fA-F]{64}$/.test(hash.trim());
}

export function isCryptoWallet(w: { type?: string; address?: string | null } | null | undefined): boolean {
  if (!w) return false;
  return w.type === 'crypto' && detectNetwork(w.address) !== 'unknown';
}
